import React from 'react';

function CakeApp() {
  return (
    <div className="container">
      <h1>Cake Design</h1>
      <p>Follow the link to login to our page.</p>
      {/* Add your content here */}
    </div>
  );
}

export default CakeApp;